<script setup lang="ts">
import cvrUploadSummariesData from "@/types/responses/cvrUploadSummariesData"
import { CVR_UPLOAD_READY_STATUSES, DEVICE_TYPE_C500_ID } from "@/services/consts"
import { computed } from 'vue'
import i18n from '@/lang/i18n';

const props = defineProps<{
  item: cvrUploadSummariesData
  acordionItemStyle: string
  openRequestModal: () => void
}>()

const AVAILABLE_CVR_REQUEST_DEVICE_MODEL_TYPES = DEVICE_TYPE_C500_ID;

const uploadStatuses = computed(() => {
  if (CVR_UPLOAD_READY_STATUSES.includes(props.item.latest_status)) return i18n.global.t('pages.cvr_uploads.waitting')
  return ''
})

const displayRequestButton = computed(() => {
  return props.item.device_id && props.item.device_model_type == AVAILABLE_CVR_REQUEST_DEVICE_MODEL_TYPES
})
</script>
<template>
  <td
    :style="props.acordionItemStyle"
    v-if="uploadStatuses"
    class="text-center"
  >
    {{ uploadStatuses }}
  </td>
  <td
    v-else-if="displayRequestButton"
    :style="props.acordionItemStyle"
  >
    <div
    class="d-flex justify-center"
    >
      <v-btn
        id="requestModalButton"
        class="exec-btn px-8"
        @click="props.openRequestModal"
      >
        {{ i18n.global.t('pages.cvr_uploads.requestBtn') }}
      </v-btn>
    </div>
  </td>
  <td v-else>
  </td>
</template>